module.exports = __webpack_public_path__ + "images/patterns/dark/BrickDiagonal.ad6bfbb1f14ba40b0f4a.svg";